export const setMaxLabelWidth = (element: any) => {
    const labels = element?.querySelectorAll('.dx-box-item-content label.dx-field-label, .dx-texteditor .dx-button-text')

    if (labels?.length) {
        let labelsWidth: any[] = []

        labels.forEach((label: any) => {
            const labelWidth = label.getBoundingClientRect().width
            labelsWidth = [...labelsWidth, labelWidth]
        })

        element?.style.setProperty('--max-labels-width', `${Math.max(...labelsWidth)}px`)
    }
}